export class ForbiddenError extends Error {
    constructor(message = 'Operation is not allowed') {
        super(message);
        this.name = 'ForbiddenError';
    }
}
